module.exports = __webpack_public_path__ + "media/fart-02.94b821f7.mp3";